import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const datepickerInputFn = /* @__PURE__ */ createRecipe('datepicker-input', {}, [])

const datepickerInputVariantMap = {}

const datepickerInputVariantKeys = Object.keys(datepickerInputVariantMap)

export const datepickerInput = /* @__PURE__ */ Object.assign(memo(datepickerInputFn.recipeFn), {
  __recipe__: true,
  __name__: 'datepickerInput',
  __getCompoundVariantCss__: datepickerInputFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: datepickerInputVariantKeys,
  variantMap: datepickerInputVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, datepickerInputVariantKeys)
  },
  getVariantProps: datepickerInputFn.getVariantProps,
})